/**
 * Shared `sx` fragment for the clickable outlined Chips in this module
 * (nav badge chip, collapsed rail chip). MUI applies `Mui-focusVisible` on
 * keyboard focus but paints nothing by default for outlined Chips — this
 * adds a visible ring using theme tokens only (design review Must-fix #2).
 */
import type { SxProps, Theme } from '@mui/material/styles';

export const CHIP_FOCUS_SX: SxProps<Theme> = {
  '&.Mui-focusVisible': {
    outline: '2px solid',
    outlineColor: 'primary.main',
    outlineOffset: '2px',
  },
};
